import { Injectable } from '@angular/core';
import { ApiService } from '@api/api.service';
import { AccountWithUsers } from '@api/types';
import { LocalStorageService } from '@shared/services/local-storage.service';
import { get } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  details: AccountWithUsers;

  constructor(private api: ApiService, private localStorage: LocalStorageService) {
    this.reloadDetails();
  }

  /**
   * Reloads the details from the server.
   */
  async reloadDetails() {
    this.details = await this.api.accounts.byId.get(get(this.localStorage, 'userWithToken.account.id', '')).toPromise();
  }
}
